@let branding = brandingService.branding$ | async;

@if (branding !== null && branding !== undefined) {
    @if (isLearnerMissing) {
        <mm-profile-learner-missing></mm-profile-learner-missing>
    } @else {
        <mm-badges [badgesData]="badges$"
                   [darkMode]="(teamsContextService.teamsContext$ | async)?.app.theme === 'dark'">
        </mm-badges>
    }
}
